module.exports = __webpack_public_path__ + "static/media/yunying1.1f5aea11.jpg";